import { J2000, J2000ObliquityDeg } from "./AstroConstants.js";
import { Deg2Rad } from "../math/MathEx.js";
import { Quaternion } from "../math/Quaternion.js";
export class J2000EclipticFrame {
    getOrientation() {
        return Quaternion.Identity();
    }
}
export class J2000EquatorFrame {
    static J2000EquatorFrameRotation = Quaternion.XRotation(J2000ObliquityDeg * Deg2Rad);
    getOrientation() {
        return J2000EquatorFrame.J2000EquatorFrameRotation;
    }
}
export class BodyMeanEquatorFrame {
    _equatorObject;
    _freezeEpoch;
    _isFrozen;
    constructor(equatorObject, freezeEpoch) {
        this._equatorObject = equatorObject;
        if (freezeEpoch !== undefined) {
            this._freezeEpoch = freezeEpoch;
            this._isFrozen = true;
        }
        else {
            this._freezeEpoch = J2000;
            this._isFrozen = false;
        }
    }
    getOrientation(tjd) {
        const t = this._isFrozen ? this._freezeEpoch : tjd;
        return this._equatorObject.GetEquatorOrientation(t);
    }
}
